import { render, staticRenderFns } from "./auto-assign.vue?vue&type=template&id=852ccb88&scoped=true&"
import script from "./auto-assign.component.ts?vue&type=script&lang=ts&"
export * from "./auto-assign.component.ts?vue&type=script&lang=ts&"
import style0 from "./auto-assign.scss?vue&type=style&index=0&id=852ccb88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852ccb88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('852ccb88')) {
      api.createRecord('852ccb88', component.options)
    } else {
      api.reload('852ccb88', component.options)
    }
    module.hot.accept("./auto-assign.vue?vue&type=template&id=852ccb88&scoped=true&", function () {
      api.rerender('852ccb88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery-wellcome/auto-assign/auto-assign.vue"
export default component.exports